import React, { useState } from "react";
import { BackTop, Button, Skeleton, Tabs } from "antd";
import styles from "./index.module.scss";
import classNames from "classnames";
import { BusinessKey, queryAskList, QueryType } from "../../../service/discuss";
import QueryForm from "./Components/QueryForm";
import AskList from "./Components/AskList";
import SetNoticeModal from "../Components/SetNoticeModal";
import useModalHandler from "../../../utils/v3/useModalHandler";
import useRequest from "../../../utils/useRequest";

export default function PageAskTeacherMain() {
    const [query, setQuery] = useState<QueryType>(QueryType.All);
    const [keyword, setKeyword] = useState("");
    const [sort, setSort] = useState<BooleanValue>("0");

    const [data, { loading }, reload] = useRequest(
        async () => queryAskList({ query, keyword, sort }),
        {},
        [query, keyword, sort]
    );

    const setModal = useModalHandler({
        component: SetNoticeModal
    });

    function openModal() {
        setModal.open({
            businessKey: BusinessKey.Aks,
            onSuccess: () => setModal.close()
        });
    }

    const tabBarExtraContent = (
        <Button type="link" icon="setting" onClick={openModal}>
            设置
        </Button>
    );

    return (
        <div className={classNames(styles.root, "container")}>
            <Tabs
                className={styles.tabs}
                animated={false}
                destroyInactiveTabPane
                defaultActiveKey=""
                onChange={e => setQuery(e as QueryType)}>
                <Tabs.TabPane key={QueryType.All} tab="全部" />
                <Tabs.TabPane key={QueryType.Join} tab="我参与的" />
                <Tabs.TabPane key={QueryType.Blocked} tab="我屏蔽的" />
            </Tabs>
            <QueryForm onChange={setKeyword} setSort={setSort} sort={sort} />

            {loading && (
                <div className={styles.ske}>
                    {[1, 2, 3].map(item => (
                        <div key={item}>
                            <Skeleton avatar />
                        </div>
                    ))}
                </div>
            )}

            {!loading && (
                <AskList query={query} data={data || []} reload={reload} />
            )}

            <BackTop />

            {setModal.render()}
        </div>
    );
}
